<template>
  <div class="container mx-auto px-4 mt-6 mb-8">
    <div class="unlock-parks-banner bg-blue-700">
      <span class="unlock-parks-banner__spark spark-left">✦</span>

      <span class="material-icons unlock-parks-banner__icon">
        redeem
      </span>

      <p
        class="unlock-parks-banner__text"
        v-html="text"
      ></p>

      <span class="unlock-parks-banner__spark spark-right">✦</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnlockParksBanner",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
